import Vue from "vue";
import Router from "vue-router";
import index from "@/components/index";
import login from "@/view/login/index";
import pwdLogin from "@/view/pwdLogin/index";
import eval_jees from "@/view/user/eval_jees/index";
import account from "@/view/user/account/index";

import forgetpwd from "@/view/login/forgetpwd/index";
import ctp_user from "@/view/user/ctp_user/index";
import account_contrast from "@/view/user/account_contrast/index";
import grouping from "@/view/user/grouping/index";
import feedback from "@/view/feedback/index";
import download from "@/view/user/download/index";
import transfer from "@/view/user/transfer/index";

import simulation from "@/view/user/simulation/index";
import vview from "@/view/user/eval_jees/view/index";
import ctp_view from "@/view/user/ctp_user/view/index";
import help from "@/view/help/index";
import help2 from "@/view/help2/index";
import Tdownload from "@/view/Tdownload/index";
import Tdownload1 from "@/view/Tdownload1/index";
import Tdownload2 from "@/view/Tdownload2/index";
import TdownloadRisk from "@/view/TdownloadRisk/index";
// import authentication from '@/view/crm/authentication/index';
import authentication_t from "@/view/crm/authentication/authentication_t/index";
import authentication_s from "@/view/crm/authentication/authentication_s/index";
import crm from "@/view/crm/index";
import qyQuery from "@/view/crm/qyQuery/index";
import team from "@/view/crm/team/index";
import state from "@/view/crm/qyQuery/state/index";
import invitation from "@/view/crm/invitation/index";
import succ from "@/view/crm/invitation/succ/index";
import mechanism from "@/view/crm/mechanism/index";
import InvestorManage from "@/view/crm/InvestorManage/index";
import details from "@/view/crm/InvestorManage/details/index";
import manager from "@/view/crm/manager/index";

import contract from "@/view/crm/contract/index";
import CDetails from "@/view/crm/contract/CDetails/index";
import user from "@/view/crm/user/index";
import analysis from "@/view/crm/analysis/index";
import remindSet from "@/view/crm/remindSet/index";
import news from "@/view/crm/news/index";
import Ranking from "@/view/crm/Ranking/index";
import Fitting from "@/view/crm/analysis/Fitting/index";
import uDetails from "@/view/crm/user/details/index";
import report from "@/view/crm/report/index";
import yunReport from "@/view/crm/yunReport/index";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: index
    },
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/user/eval_jees/list",
      name: "eval_jees",
      component: eval_jees
    },
    {
      path: "/user/account/list",
      name: "account",
      component: account
    },
    {
      path: "/user/grouping/list",
      name: "grouping",
      component: grouping
    },

    {
      path: "/index/pwdLogin2",
      name: "pwdLogin",
      component: pwdLogin
    },
    {
      path: "/login/forgetpwd",
      name: "forgetpwd",
      component: forgetpwd
    },
    {
      path: "/user/ctp_user/list",
      name: "ctp_user",
      component: ctp_user
    },
    {
      path: "/user/account_contrast/list",
      name: "account_contrast",
      component: account_contrast
    },
    {
      path: "/user/sim_user/download",
      name: "download",
      component: download
    },
    {
      path: "/index/transfer",
      name: "transfer",
      component: transfer
    },

    {
      path: "/user/sim_user/list",
      name: "simulation",
      component: simulation
    },
    {
      path: "/index/feedback/put",
      name: "feedback",
      component: feedback
    },
    {
      path: "/index/help/faq",
      name: "help",
      component: help
    },
    {
      path: "/index/help/faq2",
      name: "help2",
      component: help2
    },
    {
      path: "/user/eval_jees/view",
      name: "vview",
      component: vview
    },
    {
      path: "/user/ctp_user/view",
      name: "ctp_view",
      component: ctp_view
    },
    {
      path: "/index/download",
      name: "Tdownload",
      component: Tdownload
    },
    // 易小助下载页
    {
      path: "/index/download1",
      name: "Tdownload1",
      component: Tdownload1
    },
    // 多账户下载页
    {
      path: "/index/download2",
      name: "Tdownload2",
      component: Tdownload2
    },
    // 移动风控下载页
    {
      path: "/index/downloadRisk",
      name: "TdownloadRisk",
      component: TdownloadRisk
    },
    //CRM首页
    {
      path: "/crm/index",
      name: "crm",
      component: crm
    },
    //企业查询qyQuery
    //企业认证1
    {
      path: "/crm/qyQuery",
      name: "qyQuery",
      component: qyQuery
    },
    //审核中
    {
      path: "/crm/qyQuery/state",
      name: "state",
      component: state
    },
    // {
    //   path: '/crm/authentication',
    //   name: 'authentication',
    //   component: authentication,
    // },
    //企业认证2
    {
      path: "/crm/authentication_t",
      name: "authentication_t",
      component: authentication_t
    },
    //企业认证2
    {
      path: "/crm/authentication_s",
      name: "authentication_s",
      component: authentication_s
    },
    //团队管理
    {
      path: "/crm/team",
      name: "team",
      component: team
    },
    //邀请链接invitation
    {
      path: "/crm/invitation",
      name: "invitation",
      component: invitation
    },
    {
      path: "/crm/invitation/succ",
      name: "succ",
      component: succ
    },
    //合作方信息
    {
      path: "/crm/mechanism",
      name: "mechanism",
      component: mechanism
    },
    // 投顾管理
    {
      path: "/crm/InvestorManage",
      name: "InvestorManage",
      component: InvestorManage
    },
    //投顾详情
    {
      path: "/crm/InvestorManage/details",
      name: "details",
      component: details
    },
    //合作管理
    {
      path: "/crm/contract",
      name: "contract",
      component: contract
    },
    //合作详情
    {
      path: "/crm/contract/CDetails",
      name: "CDetails",
      component: CDetails
    },
    //分组管理
    {
      path: "/crm/manager",
      name: "manager",
      component: manager
    },
    //账号管理
    {
      path: "/crm/user",
      name: "user",
      component: user
    },
    //账号详情
    {
      path: "/crm/user/uDetails",
      name: "uDetails",
      component: uDetails
    },
    //数据分析
    {
      path: "/crm/analysis",
      name: "analysis",
      component: analysis
    },
    //拟合分析
    {
      path: "/crm/analysis/Fitting",
      name: "Fitting",
      component: Fitting
    },

    //提醒设置
    {
      path: "/crm/remindSet",
      name: "remindSet",
      component: remindSet
    },
    // 消息
    {
      path: "/crm/news",
      name: "news",
      component: news
    },
    // 排行榜
    {
      path: "/crm/Ranking",
      name: "Ranking",
      component: Ranking
    },
    // 导出评估报告
    {
      path: "/crm/report",
      name: "report",
      component: report
    },
    // 导出评估报告 yun
    {
      path: "/crm/yunReport",
      name: "yunReport",
      component: yunReport
    },

    {
      path: "*", // 错误路由
      redirect: "/" //重定向
    }
  ]
});

// 全局路由守卫
router.beforeEach((to, form, next) => {
  //如果进入到的路由是登录页或者注册页面，则正常展示
  if (
    to.name == "login" ||
    to.name == "register" ||
    to.name == "help" ||
    to.name == "help2" ||
    to.name == "Tdownload" ||
    to.name == "Tdownload1" ||
    to.name == "Tdownload2" ||
    to.name == "forgetpwd" ||
    to.name == "authentication" ||
    to.name == "transfer" ||
    to.name == "pwdLogin" ||
    to.path == "/"
  ) {
    next();
  } else if (!localStorage.getItem("token")) {
    // alert('还没有登录，请先登录！');
    // console.log(to.path, to);
    localStorage.setItem(
      "path",
      `${to.path}${to.query.type ? "?type=" + to.query.type : ""}`
    );
    next("/login"); //转入login登录页面，登录成功后会将token存入localStorage
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js